import $ from 'jquery'
import PhotoSwipe from 'photoswipe'
import PhotoSwipeUIDefault from 'photoswipe/dist/photoswipe-ui-default'

import BaseComponent from 'scripts/components/base-component'

const DEFAULTS = {
  zoomContainer: '.pswp',
  imagesSelector: '.slick-slide:not(.slick-cloned) [data-image]'
}

class ImageZoom extends BaseComponent {
  static componentName = 'image-zoom'

  static DOMEvents = {
    'click [data-image]': 'onImageClick'
  }

  constructor (element, options = {}) {
    super(element)
    this.options = $.extend({}, DEFAULTS, options)
  }

  init () {
    this.Plugin = PhotoSwipe
    this.items = this.getImages()
    this.container = $(this.options.zoomContainer)[0]
  }

  onImageClick (event) {
    const $element = $(event.target).closest('[data-image]')
    const index = +$element.attr('data-index')

    this.showPlugin(index)
  }

  showPlugin (index = 0) {
    const options = {
      maxSpreadZoom: 1,
      allowPanToNext: false,
      clickToCloseNonZoomable: false,
      history: false,
      index
    }

    const plugin = new this.Plugin(
      this.container,
      PhotoSwipeUIDefault,
      this.items,
      options
    )

    plugin.init()
  }

  getImages () {
    const images = this.$element.find(this.options.imagesSelector)

    return images.map((_index, elem) => {
      return {
        src: elem.getAttribute('data-image'),
        title: elem.getAttribute('data-caption'),
        w: elem.getAttribute('data-width'),
        h: elem.getAttribute('data-height')
      }
    })
  }
}

export default ($el) => new ImageZoom($el, $el.data()).init()

export { ImageZoom as Component }
